import React from 'react';
import { Helmet } from 'react-helmet';
import { Translation } from "react-i18next";
import BgWithText from '../../components/backgroundWithText/BgWithText';
import Image from "../../components/image";
import { asset } from '../../helpers/dom.helper';
import { Media, MediaContextProvider } from '../../media';
import Guarantee from "../../pages/Home/guaranteeHome";
import RegisterHome from "../../pages/Home/registerHome";
import './style.css'

export default class Partner extends React.Component {

  render() {
    return (
      <Translation ns={['translation', 'whyPartner']}>
        {t => (
          <>
            <Helmet>
              <title>{t('whyPartner:Partner with us')}</title>
              <meta name="description" content={t('whyPartner:Partner with us')} />
              <meta name="keywords" content={t('whyPartner:Partner with us')} />              
              <link rel="canonical" href="https://silverman.app/partner-with-us" />
            </Helmet>

            <MediaContextProvider>
              <Media lessThan="md">
                <BgWithText
                  data={{
                    title: t('whyPartner:title1'),
                     subtitle: t('whyPartner:submain1')
                  }}
                  image={asset('/images/forJuristic/web/account-condo.webp')}
                  height={350}
                  noBGPosition={true}
                />
              </Media>
              <Media greaterThanOrEqual="md">
                <BgWithText
                  data={{
                    title: t('whyPartner:title1'),
                    subtitle: t('whyPartner:submain1')
                  }}
                  image={asset('/images/forJuristic/web/account-condo.webp')}
                  height={350}
                  noBGPosition={true}
                />
              </Media>
            </MediaContextProvider>

            <div className="career__image_content_container">
              <div className="career__content_container_text">
                <p className="career__content_title">{t('whyPartner:title1')}</p>
                <p className="career__content_subtitle">{t('whyPartner:detail1')}</p>
                <p className='career__content_subtitle'>{t('whyPartner:detail2')} </p>
                <p className='career__content_subtitle'>{t('whyPartner:detail3')}</p>
              </div>
            </div>
            
            <div className="career__image_content_container">
              <div className="career__image_container">
                <Image src={asset('/images/partner/partner1.jpg')} alt="man in suit" className="career__image" />
              </div>
              <div className="career__content_container">
                <p className="career__content_title1">{t('whyPartner:title2')}</p>
                <p className="career__content_subtitle">{t('whyPartner:detail4')}</p>
              </div>
            </div>

            <div className="career__image_content_container">
              <div className="career__content_container">
                <p className="career__content_title1">{t('whyPartner:title3')}</p>
                <p className="career__content_subtitle" dangerouslySetInnerHTML={{ __html:t('whyPartner:detail5')}}/>     
              </div>
              <div className="career__image_container">
                <Image src={asset('/images/partner/partner2.jpg')} alt="man in suit" className="career__image" />
              </div>
            </div>

            <div className="career__image_content_container">
              <div className="career__content_container_text">
              <p className="career__content_title1">{t('whyPartner:title4')}</p>
                <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail6')}}/>
                <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail7')}}/>
              </div>
            </div>

            <div className="career__image_content_container1 offset-sm-1 pt-4" style={{paddingLeft:'5%'}}>
              <p className="career__content_title1">{t('whyPartner:title5')}</p>
              <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail8')}}/>
            </div>

            <div className="career__image_content_container">
              <div className="career__content_container_text">
              <p className="career__content_title1">{t('whyPartner:title6')}</p>
                <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail9')}}/>
              </div>
            </div>

            <div className="career__image_content_container">
              <div className="career__content_container_text">
              <p className="career__content_title1">{t('whyPartner:title7')}</p>
                <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail10')}}/>
              </div>
            </div>

            <div className="career__image_content_container">
              <div className="career__content_container_text">
              <p className="career__content_title1">{t('whyPartner:title8')}</p>
                <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail11')}}/>
              </div>
            </div>

            <div className="career__image_content_container">
              <div className="career__content_container_text">
              <p className="career__content_title1">{t('whyPartner:title9')}</p>
                <p className='career__content_subtitle' dangerouslySetInnerHTML={{ __html:t('whyPartner:detail12')}}/>
              </div>
            </div>
            <br/><br/><br/>

          <div className="row">
            <div className="col-3"></div>
            <div className="col-6 text-center">
              <div className="register">
                <MediaContextProvider>
                    <Media greaterThanOrEqual="md">
                        <RegisterHome />
                    </Media>
                </MediaContextProvider>
              </div>
            </div>
            <div className="col-3"></div>
          </div><br></br><br></br>
          <Guarantee />
          </>
        )}
      </Translation>
    )
  }

}

